import { appURLs } from "@/app/constants.mjs";
import globals from "@/util/global-whitelist.mjs";

const APP_ROUTE_REGEXP = /^\/(app\/|v(?=\d))([^/]*)(.*)/;

// Check if the initial pathname matches app.
const initialPathMatch = globals.location?.pathname?.match(APP_ROUTE_REGEXP);
export const APP_ROUTE_TYPE = initialPathMatch ? initialPathMatch[1] : null;
export const APP_ROUTE_VERSION = initialPathMatch ? initialPathMatch[2] : null;
export const IS_APP_ROUTE = Boolean(initialPathMatch);

export function rewritePathname(pathname: string) {
  if (IS_APP_ROUTE) {
    return `/${APP_ROUTE_TYPE}${APP_ROUTE_VERSION}${pathname}`;
  }
  return pathname;
}

export function getReCreationPath(pathname: string) {
  if (IS_APP_ROUTE && !pathname.includes("/in-game")) {
    const url = new URL(pathname);
    const strippedPathname = url.pathname.replace(
      APP_ROUTE_REGEXP,
      (_, type, version) => `/${type}${version}`,
    );
    return url.origin + strippedPathname;
  }
  return pathname;
}

/**
 * Normalizes the pathname and returns the part of the route after the app version without a trailing slash.
 */
export function normalizePathname(pathname: string) {
  if (typeof pathname !== "string") return;

  // Normalize /app/ routes.
  const appMatch = pathname.match(APP_ROUTE_REGEXP);
  if (appMatch) return appMatch[3] || "/";

  // Normalize trailing slash for all routes except root
  return pathname.replace(/\/$/, "") || "/";
}

/**
 * Normalize the origin to ensure the shared URL is always Blitz
 */

export function normalizeOrigin(origin: string) {
  const url = new URL(origin);
  if (url.hostname === "localhost") {
    return origin;
  }

  return appURLs.BLITZ;
}
